var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/* eslint-disable @rushstack/security/no-unsafe-regexp */
/* eslint-disable no-constant-condition */
import React, { useContext, useEffect, useState } from 'react';
import { Flex, Card, Text, Link } from 'pcln-design-system';
import { TravelBotAvatar } from './TravelBotAvatar';
import { ChatbotDataContext } from './context/ChatbotDataContext';
var COSTUMER_SUPPORT_NUMBER = '1-877-477-5807';
var pricelineHyperLinkRegExpPattern = /http(s)?:\/\/(www\.)?priceline\.com((\/(\w|-)+)+?)+(\/)?(\?)?(((\w)+\=(\w)+&?)?)+/;
var phoneNumberRegexPattern = /(\d-)?\d{3}-\d{3}-\d{4}/;
var regExpPatternList = [
    {
        type: 'phoneNumber',
        pattern: phoneNumberRegexPattern,
    },
    {
        type: 'hyperlink',
        pattern: pricelineHyperLinkRegExpPattern,
    },
];
var setHyperlinkFormatInContent = function (_a) {
    var content = _a.content, regexPatternIndex = _a.regexPatternIndex;
    try {
        var _b = regExpPatternList[regexPatternIndex], type = _b.type, pattern = _b.pattern;
        var newRegExp = new RegExp(pattern, 'g');
        var previousMatchedIndex = 0;
        var finalList = [];
        while (true) {
            var result = newRegExp.exec(content);
            if (result) {
                var matchedContent = result[0];
                var index = result.index;
                var preFix = content
                    .slice(previousMatchedIndex, index + matchedContent.length)
                    .replaceAll(matchedContent, '');
                previousMatchedIndex = index + matchedContent.length;
                if (regexPatternIndex + 1 < regExpPatternList.length) {
                    var nextFormatedList = setHyperlinkFormatInContent({
                        content: preFix,
                        regexPatternIndex: regexPatternIndex + 1,
                    });
                    finalList.push.apply(finalList, __spreadArray(__spreadArray([], nextFormatedList, false), [{
                            preFix: nextFormatedList.length === 0 ? preFix : '',
                            matchedContent: matchedContent,
                            type: type,
                        }], false));
                }
                else {
                    finalList.push({
                        preFix: preFix,
                        matchedContent: matchedContent,
                        type: type,
                    });
                }
            }
            else {
                var preFix = content.slice(previousMatchedIndex);
                if (regexPatternIndex + 1 < regExpPatternList.length) {
                    var nextFormatedList = setHyperlinkFormatInContent({
                        content: preFix,
                        regexPatternIndex: regexPatternIndex + 1,
                    });
                    finalList.push.apply(finalList, nextFormatedList);
                }
                else {
                    finalList.push({
                        preFix: preFix,
                        matchedContent: '',
                        type: '',
                    });
                }
                break;
            }
        }
        return finalList;
    }
    catch (_) {
        return [];
    }
};
/**
 * TravelBotChatSingleDialogGeneric
 * Support showing message content for assistan/user
 * @public
 */
export var TravelBotChatSingleDialogGeneric = function (props) {
    var _a = useContext(ChatbotDataContext), logCustomerCarePhoneNumberClicked = _a.logCustomerCarePhoneNumberClicked, logCustomerCarePhoneNumberDisplayed = _a.logCustomerCarePhoneNumberDisplayed;
    var message = props.message;
    var content = message.content, role = message.role;
    var isAssistant = role === 'assistant';
    var _b = useState([]), linesOfContents = _b[0], pushOneLineContent = _b[1];
    function phoneNumberClicked() {
        if (logCustomerCarePhoneNumberClicked && typeof logCustomerCarePhoneNumberClicked === 'function') {
            logCustomerCarePhoneNumberClicked();
        }
    }
    useEffect(function () {
        var finalLinesOfContents = [];
        content.split('\n').forEach(function (sc) {
            var oneLineContent = setHyperlinkFormatInContent({
                content: sc,
                regexPatternIndex: 0,
            });
            finalLinesOfContents.push(oneLineContent);
        });
        pushOneLineContent(finalLinesOfContents);
    }, [content]);
    return (React.createElement(Flex, { mb: 3 },
        isAssistant && React.createElement(TravelBotAvatar, null),
        React.createElement(Card, { borderRadius: 16, ml: isAssistant ? 3 : 'auto', p: 2, bg: isAssistant ? 'primary.light' : 'background.light' },
            React.createElement(Text, { fontSize: 2 }, linesOfContents.map(function (oneLine, lIndex) {
                oneLine.map(function (cont) {
                    if (cont.type === 'phoneNumber' &&
                        cont.matchedContent === COSTUMER_SUPPORT_NUMBER &&
                        logCustomerCarePhoneNumberDisplayed &&
                        typeof logCustomerCarePhoneNumberDisplayed === 'function') {
                        logCustomerCarePhoneNumberDisplayed();
                    }
                });
                return (React.createElement(Text, { fontSize: 2, key: "chat-content-line-".concat(lIndex) }, oneLine.map(function (cont, cIndex, arr) {
                    return (React.createElement(React.Fragment, { key: "cont-".concat(cIndex) },
                        cont.preFix,
                        cont.type === 'phoneNumber' && (React.createElement(Link, { href: "tel:".concat(cont.matchedContent.replace(/\D/g, '')), onClick: cont.matchedContent === COSTUMER_SUPPORT_NUMBER ? phoneNumberClicked : undefined }, cont.matchedContent)),
                        cont.type === 'hyperlink' && (React.createElement(Link, { href: cont.matchedContent, title: "hyper link for ".concat(cont.matchedContent), target: '_blank' }, cont.matchedContent))));
                })));
            })))));
};
//# sourceMappingURL=TravelBotChatSingleDialogGeneric.js.map